// this function is needed due to inconsistency among fields' names in different requests

// also we extract empty strings from avatars_for_adding
// (consequences from how everything works in src/pages/makeEvent/layout/common/uploadPhoto/index.tsx)
// TO-DO - fix it in a proper way
import { getGMTOffset } from "@utils/timezone.utils"


export default function transformFieldsNames(formikValues) {
	const { event_name, event_address, start_time, end_time, show_event_in_search, send_to_all_users_by_interessts,
		avatars_for_adding, avatars_for_deleting,
		description, event_id, organizer_id, event_type_id, contact_info,
	  is_private, is_eighteen_year_limit, has_alcohol, is_free, event_price } = formikValues
	
	const correctBodyForUpdateRequest = {
		name: event_name,
		description,
		event_id,
		organizer_id,
		event_type_id,
		event_contact_info: contact_info,
		avatars_for_deleting,
		avatars_for_adding: avatars_for_adding.filter((item) => !!item),
		address_dto: event_address,
		event_start_date_time: start_time,
		event_end_date_time: end_time,
		is_private,
	  is_show_in_search: show_event_in_search,
		is_send_by_interests: send_to_all_users_by_interessts,
		is_eighteen_year_limit,
		has_alcohol,
		is_free,
		event_price,
		time_zone: getGMTOffset()
	}
	return correctBodyForUpdateRequest
}